module.exports = __webpack_public_path__ + "static/media/191CS140.3293ff5d.jpg";